import { transformGoalSectionToGoal as _transformGoalSectionToGoal } from '@griply/services';
import {
  collection,
  doc,
  Firestore,
  serverTimestamp,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { chunkArray } from 'shared/utils/chunk-array';

import { getTaskDocs } from './get-tasks';
import { getDatabase } from './helpers';

export type Options = {
  goal: Goal;
  isSubGoal?: boolean;
};

export const transformGoalSectionToGoal = async (
  sectionId: ID,
  { goal, isSubGoal }: Options,
) => {
  const section = goal.sections?.find(({ id }) => id === sectionId);
  if (!section) {
    return;
  }

  const tasks = (
    await Promise.all(
      chunkArray(section.tasks, 30).map((ids) => getTaskDocs({ ids })),
    )
  ).flat(1);

  return _transformGoalSectionToGoal({
    sectionId,
    goal,
    isSubGoal,
    tasks,
    collection,
    doc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch: (db) => writeBatch(db as Firestore),
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.TransformGoalSectionToGoal,
        error,
      }),
  });
};
